<template>
  <div class="form-wrapper select-none">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">
            视频连线
            <button
              type="button"
              aria-label="Close"
              class="el-dialog-close-btn"
              @click="onBack"
            >
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
          </div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-container class="content">
        <div class="contact-body">
          <div class="contact-container-wrapper" ref="contactwrapper">
            <div class="contact-container">
              <div class="local video-wrapper" v-for="item in windowCount" :key="item">
                <div class="video-wrapper-outter">
                  <video autoplay muted></video>
                  <div class="video-wrapper-inner">
                    <i class="el-icon-plus add-contact-btn" @click="handleAddContact"></i>
                  </div>
                </div>
                <div class="video-control-btns">
                  <div class="mute-btn" @click="handleMute(item)">
                    <i
                      :class="{ 'el-icon-microphone': !isMuted(item), 'el-icon-turn-off-microphone':isMuted(item) }"
                    ></i>
                    <span>{{ !isMuted(item)? '静音': '取消' }}</span>
                  </div>
                  <div class="stop-btn" @click="handleKick(item)">
                    <i class="el-icon-switch-button"></i>
                    <span>关闭</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </zj-layout-container>
    </el-form>
    <el-dialog
      class="emergencyoperations-dialog thin"
      custom-class="bg2"
      top="15vh"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isAddContactVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <ZJEmergencyComponentAddContact
        v-bind:ExecutId="ExecutId"
        :roomId="roomId"
        :pwd="pwd"
        @handlerclose="isAddContactVisible=false"
      />
    </el-dialog>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../../apis";

import ZJEmergencyComponentAddContact from "./Component-AddContact";

export default {
  name: "ZJEmergencyComponentRealtimeCallWin",
  componentName: "ZJEmergencyComponentRealtimeCallWin",
  components: {
    ZJEmergencyComponentAddContact,
  },
  props: {
    allVideos: Object,
    ExecutId: {
      type: String,
      required: true,
    },
    roomId: {
      type: String,
    },
    pwd: {
      type: String,
    },
    mute: {
      type: Boolean,
    },
  },
  data() {
    return {
      windowCount: 8,
      isAddContactVisible: false,
      muted: false,
      mutedChange: false,
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init: function () {
      let that = this;
      let videoControls = that.$refs.contactwrapper.querySelectorAll("video");

      if (this.allVideos.length > 8) {
        this.windowCount = this.allVideos.length;
      } else if (this.windowCount > 8) {
        this.windowCount = 8;
      }

      for (let i = 0; i < this.windowCount; i++) {
        var srcVideo = this.allVideos[i];
        if (srcVideo) {
          var stream = srcVideo.video.captureStream();
          videoControls[i].srcObject = stream.clone();
        } else {
          videoControls[i].srcObject = null;
        }
      }
    },
    onBack: function () {
      this.$emit("handlerclose");
    },
    getStream: function (srcVideo) {
      // eslint-disable-next-line no-unused-vars
      var that = this;
      var stream = srcVideo.captureStream();
      return stream.clone();
    },
    handleAddContact: function () {
      this.isAddContactVisible = true;
    },
    // eslint-disable-next-line no-unused-vars
    handleMute(index) {
      if (this.allVideos.length > 0) {
        if (index == 1) {
          this.$emit("handleMuteLocal");
        } else {
          let id = this.allVideos[index - 1].id;
          let muted = this.allVideos[index - 1].muted;

          this.mutedChange = true;
          this.$emit("handleMute", { id: id, muted: muted, index: index });
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    handleKick(index) {
      if (this.allVideos.length > 0) {
        if (index == 1) {
          this.$emit("handleDeleteRoom");
        } else {
          let id = this.allVideos[index - 1].id;
          this.$emit("handleKick", id);
        }
      }
    },
  },
  computed: {
    isMuted() {
      return function (index) {
        if (index == 1) {
          return this.mute;
        } else {
          return this.allVideos && this.allVideos.length >= index
            ? this.allVideos[index - 1].muted
            : false;
        }
      };
    },
  },
  watch: {
    allVideos: {
      // eslint-disable-next-line no-unused-vars
      handler(val, oldVal) {
        console.log(val);
        //仅静音的话不重新渲染视频。并恢复mutedChange值
        if (!this.mutedChange) {
          this.init();
        }else{
          this.mutedChange = false;
        }
      },
      deep: true,
    },
    mute: {
      // eslint-disable-next-line no-unused-vars
      handler(val, oldVal) {
        this.mute = val;
      },
    },
  },
};
</script>